import { useTranslation } from "react-i18next"

import Table, { Body, Header, HeaderCell } from "@/components/Table/Table"
import type { StudentProject } from "@/types/projectTypes"

import ProjectsItem from "./ProjectsItem"

export default function ProjectsShow({
  projects,
}: {
  projects: Array<StudentProject>
}) {
  const { t } = useTranslation()
  return (
    <div>
      <Table>
        <Header>
          <HeaderCell>{t("projectsPage.table.no")}</HeaderCell>
          <HeaderCell>{t("projectsPage.table.name")}</HeaderCell>
          <HeaderCell>{t("projectsPage.table.description")}</HeaderCell>
          <HeaderCell>{t("projectsPage.table.link")}</HeaderCell>
          <HeaderCell>{t("projectsPage.table.video")}</HeaderCell>
          <HeaderCell>{t("projectsPage.table.comment")}</HeaderCell>
          <HeaderCell></HeaderCell>
        </Header>
        <Body>
          {projects?.map((ele, index) => {
            return <ProjectsItem from={1 + index} key={ele.id} ele={ele} />
          })}
        </Body>
      </Table>
    </div>
  )
}
